import "./style.scss";

import Google from "assets/img/svg/googleIcon";
import type { TIntegrationName } from "components/IntegrationsSettings/types";
import ModalBox from "components/Modal";
import { useTranslation } from "react-i18next";
import type { IIntegrations } from "store/integrationsStore";
import { authGoogleAccount, createIntegration } from "store/integrationsStore";
import { useAppDispatch, useAppSelector } from "store/store";

import IntegrationElement from "./IntegrationElement";

interface IConnectIntegrationModal {
    open: boolean;
    onClose: () => void;
}

const ConnectIntegrationModal = ({ open, onClose }: IConnectIntegrationModal) => {
    const [t] = useTranslation();
    const dispatch = useAppDispatch();
    const integrations = useAppSelector((state) => state.integrations.integrations);

    const isPendingIntegration = (integrationName: TIntegrationName) => {
        return integrations.find(
            (integration: IIntegrations) => integration.partner === integrationName && integration.status == 1,
        );
    };

    const integrationList = [
        {
            name: "Google",
            logo: <Google />,
            btnTxt: t("IntegrationsSettings.ConnectGoogleAccount"),
            onConnect: async () => {
                if (!isPendingIntegration("google")) await dispatch(createIntegration({ partner: "google" }));
                localStorage.setItem("oauthRedirectionPath", "/settings/partner-statements/new");
                dispatch(authGoogleAccount());
            },
        },
    ];

    return (
        <ModalBox mainTitle={t("PartnerStatements.ConnectIntegration")} open={open} onClose={onClose}>
            <div className="connect-integration-modal">
                {integrationList.map((integration) => (
                    <IntegrationElement
                        key={`integration-modal-block-${integration.name}`}
                        integrationName={integration.name}
                        logo={integration.logo}
                        btnTxt={integration.btnTxt}
                        onConnect={integration.onConnect}
                    />
                ))}
            </div>
        </ModalBox>
    );
};

export default ConnectIntegrationModal;
